import React from 'react';
import { ReactComponent as UploadIcon } from 'src/assets/tailwind/upload-files.svg';
import { Button } from 'src/components/ui/button';
import { Icon } from 'src/components/ui/icon';
import { Typography } from 'src/components/ui/typography';
import { cn } from 'src/utils/utils';

export interface EmptyStatePlaceHolderProps {
  title: string;
  description?: string;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  borderless?: boolean;
  className?: string;
  actionButton?: {
    text: string;
    onClick: (e) => void;
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  };
}

export function EmptyStatePlaceHolder({
  title,
  description,
  actionButton,
  borderless = false,
  className,
  icon: IconComponent = UploadIcon
}: EmptyStatePlaceHolderProps) {
  return (
    <div
      className={cn(
        `
        tw:h-150
        tw:max-h-150
        ${
          borderless
            ? ''
            : 'tw:border tw:border-dashed tw:border-border-primary tw:rounded-bw-2xl-3xl'
        }
        tw:py-3xl tw:px-5xl
        tw:flex tw:flex-col tw:items-center tw:justify-center
        tw:gap-l
        tw:w-full
        tw:text-center`,
        className
      )}
    >
      <div className="tw:w-14 tw:h-14 tw:flex tw:items-center tw:justify-center tw:rounded-full tw:bg-brand-light">
        <Icon icon={IconComponent} size={24} />
      </div>

      <div className="tw:flex tw:flex-col tw:items-center tw:gap-l tw:w-full tw:max-w-251">
        <Typography
          variant="h4"
          colorClass="tw:text-text-primary"
          className="tw:text-center"
        >
          {title}
        </Typography>

        {!!description && (
          <Typography
            variant="b2"
            colorClass="tw:text-text-secondary"
            className="tw:text-center"
          >
            {description}
          </Typography>
        )}
      </div>

      {!!actionButton && (
        <Button
          hierarchy="secondary"
          text={actionButton.text}
          leftIcon={actionButton.icon}
          onClick={actionButton.onClick}
          size="small"
          className="tw:h-10 tw:min-h-10 tw:py-0"
        />
      )}
    </div>
  );
}
